import useApi from './useApi';

const useInventoryService = () => {
  const { api } = useApi();

  const getProducts = ({ type }) => api({
    method: 'get',
    url: '/product-inventory/v1/establishments/own/products',
    params: {
      type,
    },
  });

  const getInventories = ({ type, start, end }) => api({
    method: 'get',
    url: '/product-inventory/v1/establishments/own/inventories',
    params: {
      startDateIncluded: start,
      endDateExcluded: end + 1,
      productType: type,
    },
  });

  const putInventoryQuantity = ({ inventoryId, quantity }) => api({
    method: 'put',
    url: `/product-inventory/v1/establishments/own/inventories/${inventoryId}/quantity`,
    data: {
      quantity,
    },
  });

  const putInventoryYield = ({ inventoryId, yielding }) => api({
    method: 'put',
    url: `/product-inventory/v1/establishments/own/inventories/${inventoryId}/yielding`,
    data: {
      yielding: yielding.toFixed(2),
    },
  });

  const postInventoryStatus = ({ inventoryId, isActive }) => api({
    method: 'post',
    url: `/product-inventory/v1/establishments/own/inventories/${inventoryId}:${isActive ? 'activate' : 'deactivate'}`,
  });

  return {
    getProducts,
    getInventories,
    putInventoryQuantity,
    putInventoryYield,
    postInventoryStatus,
  };
};

export default useInventoryService;
